import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { AuthWrapper, AuthContainer, LangDropdown } from 'components/ui/index';
import classNames from 'classnames/bind';
import { hideLoading, showLoading } from 'store/loading/loadingAction';
import loginBg from 'assets/images/auth-login-bg.png';
import styles from '../loginForm.less';
import { tryLogin } from '../flow/actions';
import LoginForm from '../components/LoginForm';

const cx = classNames.bind(styles);

const LoginPage = (props) => {
  const { errors } = props;

  if (
    errors &&
    errors.errors.some(error => !!error.forceLogout) &&
    Array.isArray(errors.errors) &&
    !!errors.errors.length
  ) window.location.reload();

  return (
    <AuthWrapper backgroundSrc={loginBg}>
      <AuthContainer
        containerClass={cx('login-container')}
        subtitle={
          <span className={cx('login-container-subtitle')}>Welcome to <span style={{ fontWeight: 'bold' }}>LogixCRM</span></span>
      }
        actions={
          <div className="text-right">
            <LangDropdown />
          </div>
      }
        actionPosition="top-right"
      >
        <LoginForm
          tryLogin={props.tryLogin}
          showLoading={props.showLoading}
          hideLoading={props.hideLoading}
        />
      </AuthContainer>
    </AuthWrapper>
  );
};

const mapStateToProps = ({ loginUser, errors }) => ({
  loginUser,
  errors
});
const mapDispatchToProps = {
  tryLogin,
  showLoading,
  hideLoading,
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/views/LoginForm/container/index.jsx